<template>
  <v-app>
    <SnackBarList />
    <HeaderApp
      v-if="showHeader"
      :maxWidth="maxWidth"
      :adminHeader="adminHeader"
    />
    <v-main>
      <RouterView />
    </v-main>
    <v-overlay
      z-index="200"
      :value="appLoader"
    >
      <v-row
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="subtitle-1 text-center"
          cols="12"
        >
          <v-img
            class="logo"
            contain
            src="./assets/icons/ai.png"
            max-width="200px"
          />
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="#102d69"
            indeterminate
            rounded
            height="6"
          />
        </v-col>
      </v-row>
    </v-overlay>
  </v-app>
</template>

<script type="text/javascript">
  import SnackBarList from '@/components/ui/SnackBar/SnackBarList.vue'
  import HeaderApp from '@/components/ui/partials/HeaderApp/HeaderApp.vue'
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import RequestAPI from '@/services/RequestAPI'
  import ApiService from '@/services/ApiService'

  export default {
    components: {
      HeaderApp,
      SnackBarList,
    },
    mixins: [CommonMixin, mixinUi,],
    data() {
      return {}
    },
    computed: {
      showHeader() {
        return this.$route.meta.showHeader
      },
      adminHeader() {
        return this.$route.meta.adminHeader
      },
    },
    async beforeCreate() {
      if (localStorage.getItem('access_token')) {
        const config = await ApiService.getConfiguration()
        if (config) {
          this.$store.commit('common/setCurrentConfig', config.data)
          this.$store.commit('common/setEnumsOptions', {
            enums: config.data.enums,
            $t: this.$t.bind(this),
          })
        }
      }
    },
    mounted() {
      const title = this.$t('common.confirmation-title')
      const buttonTrueText = this.$t('common.confirmation-save-btn')
      const buttonFalseText = this.$t('common.confirmation-cancel-btn')
      const persistent = true
      if (this.isCRM) {
        RequestAPI.setCallbackCredentials(async () => {
          return this.$confirm(this.$t('common.confirmation-msg'), {
            title,
            buttonTrueText,
            buttonFalseText,
            persistent,
          })
        })
      } else {
        RequestAPI.setCallbackSSO(() => {
          return this.$confirm(this.$t('common.confirmation-msg'), {
            title,
            buttonTrueText,
            buttonFalseText,
            persistent,
          })
        })
      }
    },
  }
</script>

<style lang="scss">
@import '~@/styles/colors.scss';
@import '~@/styles/main.scss';
@import '~@/styles/variables.scss';
@import '~@/styles/titles.scss';
@import '~@/styles/paragraphs.scss';
@import '~@/styles/links.scss';
@import '~@/styles/buttons.scss';
@import '~@/styles/menus.scss';
@import '~@/styles/tags.scss';
@import '~@/styles/common.scss';
@import '~@/styles/tabs.scss';
/*
    ** STYLES
    */

main {
  // padding-top: 88px !important;
  background-color: $color-f3f6fe;
  @media (max-width: 959px) {
    padding-top: 55px;
  }
}
</style>
